import { AnyAction } from "redux";
import { initialState } from "../store/initialState";
import { actionTypeKeys } from "../actions/actionTypeKeys";
import { TitleBar } from "../types/titleBar";

export default function AppTitleBarReducer(state: TitleBar = initialState.appTitleBar, action: AnyAction): TitleBar {
  switch (action.type) {
    case actionTypeKeys.SET_APP_TITLE_BAR:
      return action.appTitleBar;
    default:
      return state;
  }
}
